export default __webpack_public_path__ + "static/media/eth.ca4e2c89.svg";